import { useNavigate } from "react-router-dom";
import { Loader2, LogOut, UserRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Reveal from "@/components/Reveal";

export default function Profile() {
  const { user, openAuth, logout } = useAuth();
  const navigate = useNavigate();

  if (user === undefined) {
    return (
      <div className="vault-container flex justify-center pt-32">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    openAuth("signin");
    return null;
  }

  return (
    <div className="vault-container max-w-xl pt-14 sm:pt-16" data-testid="profile-page">
      <Reveal>
        <p className="overline-label">Account</p>
        <h1 className="mt-2 font-display text-3xl font-semibold tracking-tighter sm:text-4xl">Profile</h1>
      </Reveal>
      <Reveal delay={0.08}>
        <div className="mt-10 rounded-2xl border border-white/[0.08] bg-card p-7">
          <div className="flex items-center gap-4">
            <span className="flex h-14 w-14 items-center justify-center rounded-full border border-white/15 bg-white/[0.04]">
              <UserRound className="h-6 w-6 text-muted-foreground" />
            </span>
            <div>
              <p className="font-medium" data-testid="profile-email">{user.email}</p>
              <p className="mt-0.5 text-xs text-muted-foreground">
                {user.role === "admin" ? "Admin" : "Customer"} · Member since{" "}
                {user.created_at ? new Date(user.created_at).toLocaleDateString() : "—"}
              </p>
            </div>
          </div>
          <button
            data-testid="profile-sign-out"
            onClick={async () => {
              await logout();
              navigate("/");
            }}
            className="mt-7 flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-sm text-muted-foreground transition-colors duration-200 hover:border-white/30 hover:text-foreground"
          >
            <LogOut className="h-4 w-4" /> Sign out
          </button>
        </div>
      </Reveal>
    </div>
  );
}
